import {Component, Input, OnInit} from '@angular/core';
import {Country} from "../../models/treaty.models";

@Component({
    standalone: false,
    selector: 'particle-withholding-tax-forms',
  templateUrl: './withholding-tax-forms.component.html',
  styleUrls: ['./withholding-tax-forms.component.scss']
})
export class WithholdingTaxFormsComponent implements OnInit {
  @Input() info: {country1: Country , country2: Country};
  @Input() countryCode1: string;
  @Input() countryCode2: string;
  constructor() { }

  ngOnInit() {
  }


  goWhtFormPage() {

  }

}
